// GENERATED by scripts/sync-shared.js from shared/passwordPolicy.json - do not edit; run `npm run shared:sync`.
export const PASSWORD_MIN_LENGTH = 12
export const PASSWORD_REQUIRE_UPPERCASE = true
